import {Subject} from 'rxjs';
import {Directive, EventEmitter, OnDestroy, inject} from '@angular/core';
import {BaseComponent} from "../base-component";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {ModalAction} from "./le-modal-ref.service";

@Directive()
export class BaseModalComponent extends BaseComponent implements OnDestroy {
  public onHide$: Subject<{ data: any, action?: ModalAction }> = new Subject<{ data: any, action?: ModalAction }>();
  public action: EventEmitter<{ action: ModalAction, data: any, modal?: NgbActiveModal }> = new EventEmitter<{ action: ModalAction, data: any, modal?: NgbActiveModal }>();
  public bsModalRef = inject(NgbActiveModal);

  constructor() {
    super();
  }

  close = (data: any = null, action: ModalAction = null, skipAction: boolean = false): void => {
    action = action ?? 'Close'
    if (!skipAction) {
      this.action.next({action: action, data: data});
    }

    this.onHide$.next({data, action});
    this.onHide$.complete();
    this.onHide$.unsubscribe();
    this.bsModalRef.close({data, action});
  };

  apply = (data: any = null, action: ModalAction = null): void => {
    this.action.next({data, action, modal: this.bsModalRef});
  };

  ngOnDestroy(): void {
    super.ngOnDestroy();
    if (!this.onHide$.closed) {
      this.action.next({action: 'Close', data: 'This action can be used to detect modal closed by ESC or backdrop click, as well as normal closing.'});
      this.onHide$.unsubscribe();
    }
  }
}

